import { ForgotPassword } from '../components/presentations/forgotPassword'

 const ForgotPasswordContainer = () => {
  return <ForgotPassword />
}
export default ForgotPasswordContainer
